module.exports = __webpack_public_path__ + "static/media/Bingo.f13213dc.pdf";